import { type FC, type PropsWithChildren, useMemo } from 'react';
import { YandexKitPartialsProvider } from '#shared/components/YandexKitProvider';
import { buildConstructorPartialDtosFromFragments } from '../../lib/buildPartials';
import { useConstructorFragments } from '../../model/slices';

/**
 * Подставляет фрагменты конструктора в getSettings / getAllSettings / denormalizeJsonSchema через useYandexKit.
 *
 * @kind component
 */
export const ConstructorYandexKitPartialsProvider: FC<PropsWithChildren> = ({ children }) => {
    const fragments = useConstructorFragments();
    const partials = useMemo(() => buildConstructorPartialDtosFromFragments(fragments), [fragments]);

    return <YandexKitPartialsProvider partials={partials}>{children}</YandexKitPartialsProvider>;
};
